import { render, staticRenderFns } from "./CreatorFormDialog.vue?vue&type=template&id=6b880e13"
import script from "./CreatorFormDialog.vue?vue&type=script&lang=js"
export * from "./CreatorFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports